// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';

export const createErrorMessage = message => ({
    message,
    messageType: 'error',
    type: actions.CREATE_ALERT_MESSAGE
});

export const deleteErrorMessage = message => ({
    message,
    messageType: 'error',
    type: actions.DELETE_ALERT_MESSAGE
});

export const dismissErrorMessages = () => ({
    messageType: 'error',
    type: actions.DISMISS_ALERT_MESSAGES
});

export const createInfoMessage = message => ({
    message,
    messageType: 'info',
    type: actions.CREATE_ALERT_MESSAGE
});

export const deleteInfoMessage = message => ({
    message,
    messageType: 'info',
    type: actions.DELETE_ALERT_MESSAGE
});

export const dismissInfoMessages = () => ({
    messageType: 'info',
    type: actions.DISMISS_ALERT_MESSAGES
});

export const createSuccessMessage = message => ({
    message,
    messageType: 'success',
    type: actions.CREATE_ALERT_MESSAGE
});

export const deleteSuccessMessage = message => ({
    message,
    messageType: 'success',
    type: actions.DELETE_ALERT_MESSAGE
});

export const dismissSuccessMessages = () => ({
    messageType: 'success',
    type: actions.DISMISS_ALERT_MESSAGES
});

export const createWarningMessage = message => ({
    message,
    messageType: 'warning',
    type: actions.CREATE_ALERT_MESSAGE
});

export const deleteWarningMessage = message => ({
    message,
    messageType: 'warning',
    type: actions.DELETE_ALERT_MESSAGE
});

export const dismissWarningMessages = () => ({
    messageType: 'warning',
    type: actions.DISMISS_ALERT_MESSAGES
});



// WEBPACK FOOTER //
// ./src/shared/action-creators/alert-messages.js